import { useEffect } from 'react'
import { createPortal } from 'react-dom'
import { Icon } from '@iconify/react'
import { Tabs } from 'antd'

import StoryMapActivityTab from './StoryMapActivityTab'
import tabStyles from '../../ProjectCommentsTabs.module.css'
import styles from './StoryMapCardDetailModal.module.css'

const StoryMapActivityModal = ({
    open,
    cardId,
    onClose,
    onLoadActivity,
}) => {
    useEffect(() => {
        if (!open) return undefined
        const onKey = (event) => {
            if (event.key === 'Escape') {
                event.preventDefault()
                event.stopPropagation()
                onClose?.()
            }
        }
        window.addEventListener('keydown', onKey, true)
        const prevOverflow = document.body.style.overflow
        document.body.style.overflow = 'hidden'
        return () => {
            window.removeEventListener('keydown', onKey, true)
            document.body.style.overflow = prevOverflow
        }
    }, [open, onClose])

    if (!open) return null

    return createPortal(
        <div
            className={styles.activityModalOverlay}
            data-story-map-activity-overlay
            onClick={onClose}
            onMouseDown={(event) => event.stopPropagation()}
            role="presentation"
        >
            <div
                className={styles.activityModal}
                role="dialog"
                aria-modal="true"
                aria-labelledby="story-map-activity-modal-title"
                onClick={(event) => event.stopPropagation()}
            >
                <div className={styles.activityModalHeader}>
                    <Tabs
                        activeKey="activity"
                        items={[
                            {
                                key: 'activity',
                                label: (
                                    <span id="story-map-activity-modal-title">
                                        All activity
                                    </span>
                                ),
                            },
                        ]}
                        className={`${tabStyles.customTabs} ${styles.activityModalTabs}`}
                        tabBarStyle={{ marginBottom: 0 }}
                    />
                    <button
                        type="button"
                        className={styles.activityModalClose}
                        onClick={onClose}
                        aria-label="Close activity"
                    >
                        <Icon icon="mdi:close" width={18} height={18} />
                    </button>
                </div>

                <div className={styles.activityModalBody}>
                    <StoryMapActivityTab
                        key={`modal-${cardId}`}
                        cardId={cardId}
                        open={open}
                        onLoadActivity={onLoadActivity}
                        isActive={open}
                        variant="modal"
                    />
                </div>
            </div>
        </div>,
        document.body
    )
}

export default StoryMapActivityModal
